import { AlertTwoTone } from "@ant-design/icons";
import { theme } from "antd";

const { useToken } = theme;

/** Properties to configure an alert indicator, that in PMS-integrated sessions denotes an unlinked P/RP. */
interface UnlinkedIndicatorProps {
    /**
     * When true, indicates P/RP is indeed unlinked, and that the indicator should be shown.
     * The indicator will also be shown when this property is undefined.
     * When false, the indicator will not be shown.
     */
    readonly unlinked?: boolean;

    /** When set, indicator is shown larger than regular text. */
    readonly large?: boolean;
}

/** In PMS-integrated sessions, denotes an unlinked P/RP when applicable. Renders as blank when not applicable. */
export const UnlinkedIndicator = ({ unlinked = true, large }: UnlinkedIndicatorProps) => {
    const { token } = useToken();

    const style = large ? { fontSize: "150%" } : undefined;
    return unlinked ? (
        <AlertTwoTone twoToneColor={token.colorPrimary} style={style} title="Not linked to a PMS Patient" />
    ) : null;
};
